package com.example.borshi.web.account

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.example.borshi.web.auth.UserProfile
import kotlinx.browser.window
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.TextArea

@Composable
fun AccountDetailsScreen(user: UserProfile, @Suppress("UNUSED_PARAMETER") onBack: () -> Unit) {
    var name by remember { mutableStateOf(user.userId ?: "") }
    var email by remember { mutableStateOf(user.email ?: "") }
    var phone by remember { mutableStateOf(user.phoneNumber ?: "") }
    var dietaryPref by remember { mutableStateOf("") }
    var notes by remember { mutableStateOf("") }
    var saved by remember { mutableStateOf(false) }

    Div({
        style {
            maxWidth(900.px)
            property("margin", "0 auto")
            padding(24.px, 16.px)
            width(100.percent)
            backgroundColor(Color("#F5F5F5"))
            minHeight(100.vh)
        }
    }) {
        Div({
            style {
                display(DisplayStyle.Flex)
                alignItems(AlignItems.Center)
                gap(16.px)
                marginBottom(24.px)
            }
        }) {

            H1({
                style {
                    fontSize(28.px)
                    fontWeight("bold")
                    color(Color("#0D2B2E"))
                    margin(0.px)
                }
            }) {
                Text("Account Details")
            }
        }

        Div({
            style {
                backgroundColor(Color.white)
                borderRadius(16.px)
                padding(32.px)
                property("box-shadow", "0 4px 16px rgba(0,0,0,0.08)")
            }
        }) {
            H2({
                style {
                    fontSize(20.px)
                    fontWeight("bold")
                    marginBottom(16.px)
                }
            }) { Text("Personal Information") }

            Div({
                style {
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(16.px)
                }
            }) {
                AccountDetailsField("Full Name", name) { name = it }
                AccountDetailsField("Email", email) { email = it }
                AccountDetailsField("Phone", phone) { phone = it }
                AccountDetailsField("Dietary Preferences", dietaryPref) { dietaryPref = it }
                AccountTextAreaField("Additional Notes", notes) { notes = it }
            }

            Button({
                style {
                    marginTop(24.px)
                    width(100.percent)
                    padding(14.px)
                    backgroundColor(Color("#D11243"))
                    color(Color.white)
                    border(0.px)
                    borderRadius(10.px)
                    fontSize(16.px)
                    fontWeight("700")
                    cursor("pointer")
                }
                onClick {
                    saved = true
                    window.setTimeout({ saved = false }, 3000)
                }
            }) {
                Text("Save Changes")
            }

            if (saved) {
                P({
                    style {
                        marginTop(12.px)
                        padding(12.px)
                        backgroundColor(Color("#E8F5E9"))
                        color(Color("#2E7D32"))
                        borderRadius(8.px)
                        fontWeight("600")
                    }
                }) {
                    Text("Details saved (local preview)")
                }
            }
        }
    }
}

@Composable
private fun AccountDetailsField(label: String, value: String, onChange: (String) -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            gap(6.px)
        }
    }) {
        Label(attrs = {
            style {
                fontWeight("600")
                color(Color("#212121"))
            }
        }) { Text(label) }
        Input(InputType.Text) {
            value(value)
            onInput { onChange(it.value) }
            style {
                padding(12.px)
                borderRadius(8.px)
                border(1.px, LineStyle.Solid, Color("#E0E0E0"))
                fontSize(14.px)
            }
        }
    }
}

@Composable
private fun AccountTextAreaField(label: String, value: String, onChange: (String) -> Unit) {
    Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(6.px) } }) {
        Label(attrs = {
            style {
                fontWeight("600")
                color(Color("#212121"))
            }
        }) { Text(label) }
        TextArea(value) {
            onInput { onChange(it.value) }
            style {
                minHeight(100.px)
                padding(12.px)
                borderRadius(8.px)
                border(1.px, LineStyle.Solid, Color("#E0E0E0"))
                fontSize(14.px)
            }
        }
    }
}
